import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import {
  GET_SELLERS,
  CREATE_SELLERS,
  DELETE_SELLERS,
  UPDATE_SELLERS,
} from "./actionType";

import { SellersApiResponseSuccess, SellersApiResponseError } from "./action";

import { notifyError, notifySuccess } from "../../components/notify";
import {
  createSellers as sellerCreate,
  deleteSellers as sellerDelete,
  getSellers as sellerGet,
  updateSellers as sellerUpdate,
} from "../../helpers/backend_helper";

function* getSellers(data) {
  try {
    const response = yield call(sellerGet, data.payload.id);
    yield put(SellersApiResponseSuccess(GET_SELLERS, response));
  } catch (error) {
    yield put(SellersApiResponseError(GET_SELLERS, error));
  }
}

function* createSellers(data) {
  try {
    const response = yield call(sellerCreate, data.payload.data);
    yield put(SellersApiResponseSuccess(CREATE_SELLERS, response));
    notifySuccess("Corretor criado com sucesso!");
  } catch (error) {
    yield put(SellersApiResponseError(CREATE_SELLERS, error));
    notifyError("Erro ao criar corretor!");
  }
}

function* updateSellers(data) {
  try {
    const response = yield call(sellerUpdate, {
      id: data.payload.id,
      data: data.payload.data,
    });
    yield put(SellersApiResponseSuccess(UPDATE_SELLERS, response));
    notifySuccess("Corretor atualizado com sucesso!");
  } catch (error) {
    yield put(SellersApiResponseError(UPDATE_SELLERS, error));
    notifyError("Erro ao atualizar corretor!");
  }
}

function* deleteSellers(data) {
  try {
    const response = yield call(sellerDelete, data.payload.id);
    yield put(SellersApiResponseSuccess(DELETE_SELLERS, response));
    notifySuccess("Corretor deletado com sucesso!");
  } catch (error) {
    yield put(SellersApiResponseError(DELETE_SELLERS, error));
    notifyError("Erro ao deletar corretor!");
  }
}

export function* watchGetSellers() {
  yield takeEvery(GET_SELLERS, getSellers);
}

export function* watchCreateSellers() {
  yield takeEvery(CREATE_SELLERS, createSellers);
}

export function* watchUpdateSellers() {
  yield takeEvery(UPDATE_SELLERS, updateSellers);
}

export function* watchDeleteSellers() {
  yield takeEvery(DELETE_SELLERS, deleteSellers);
}

function* SellersSaga() {
  yield all([fork(watchGetSellers)]);
  yield all([fork(watchCreateSellers)]);
  yield all([fork(watchUpdateSellers)]);
  yield all([fork(watchDeleteSellers)]);
}

export default SellersSaga;
